import React, {useEffect, useState} from 'react';
import {smartSearch} from '../../../helper/uiFunctions';
import AppMenuRow from './AppMenuRow';
import useSarasStore from '../../../library/hooks/localDB/useSarasStore'
import SarasPopup from '../../../library/container/popup/SarasPopup.js';
import SarasSearchInput from '../../../library/input/textField/SarasSearchInput';

const AppMenu = (props) => {
  const {anchorRef, placement, isMenuOpen, onClose, scrollToMenuRow} = props;
  const [searchFilter, setSearchFilter] = useState('');
  const [appMenus, setAppMenus] = useState([]);
  const [searchMenus, setSearchMenus] = useState(null);
  const localDb = useSarasStore();

    const loadLocalMenu = () => {
      if(!appMenus || appMenus.length === 0)
      {
          localDb.getAppMenu(onLocalMenuSuccess);
      }
    };

    useEffect(loadLocalMenu, [appMenus]);
  
    const closeAppMenu =()=>{
      setSearchFilter('');
      setAppMenus([]);
      onClose();
    }

    const getSearchResult = (filterBy, menus) => {
      
      //set search result to blank if filter param is missing
      if(!filterBy) {
        setSearchMenus(null);
        return;
      }

      let result = [{MenuLink: '', MenuTitle: 'Search Result(s) ' 
        + (filterBy.length <= 2 ? ' starting with ' : ' containing ') 
        + filterBy, MenuIcon: 'search', ChildMenus: []}];
      let ciParam = filterBy.toLowerCase();

      for (var i = 0; i < menus.length; i++) {
        let menu = menus[i];

        if(!menu.MenuType){
          for (var ci = 0; ci < menu.ChildMenus.length; ci++) {
            if (smartSearch(menu.ChildMenus[ci].MenuTitle, ciParam) ||
                smartSearch(menu.ChildMenus[ci].Keyword, ciParam)) {
              result[0].ChildMenus.push(menu.ChildMenus[ci]);
            }
          }
        }
      }
  
      setSearchMenus(result);
    }

    const onLocalMenuSuccess = (key, value) =>  {
      if(value && typeof value != "string"){
        setAppMenus(value);

        if(searchFilter != null && value.length > 0) getSearchResult(searchFilter, value);
      }
    }

    const onSearchParamChange = (e, value) => {
      setSearchFilter(value.trim());
      getSearchResult(value.trim(), appMenus);
    }

  return (
    <SarasPopup anchorRef={anchorRef} open={isMenuOpen} onClose={closeAppMenu} placement={placement}>
        <div className="uiAppMenu" style={{height:"500px", width:"450px",overflowY: "auto"}}>
          <div className="uiAppMenuSearch">
            <SarasSearchInput ksc="esc" placeholder="Search all your SarasX menu" 
            className="uiAppMenuSearchBar"
            elevation={1}
            value={searchFilter || ''}
            // tooltip="Search all your SarasX menu" tooltipAlign="right" autofocus type='search' 
            onSearchAsKeyed={onSearchParamChange}/>
          </div>
          <div className='uiMenuGroupContainer'>
            {(searchMenus || appMenus).map((menu, index) => {
              return (
                menu.MenuType !== 's' ? (
                  <AppMenuRow
                    menuRow={menu}
                    key={index}
                    onMenuSelect={closeAppMenu}
                    scrollToMenuRow={scrollToMenuRow}
                  />
                ) : null
              );
            })}
          </div>
        </div>
    </SarasPopup>
    )
}

export default AppMenu;
